import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/list-master/districts";

export const Route = createFileRoute("/admin/_list-master/districts")({
  component: Page,
});
